import useSWR from 'swr'
import { DashboardApiClient } from 'services/dashboard/DashboardApiClient'

const apiClient = new DashboardApiClient()

export const useGetAttendeeProfile = (enabled: boolean) => {
  const { key, fetcher } = apiClient.getAttendeeProfile()
  return useSWR(enabled ? key : null, fetcher)
}
